import { render, staticRenderFns } from "./payment-success.vue?vue&type=template&id=9851d6b0&scoped=true"
import script from "./payment-success.vue?vue&type=script&lang=js"
export * from "./payment-success.vue?vue&type=script&lang=js"
import style0 from "./payment-success.vue?vue&type=style&index=0&id=9851d6b0&prod&lang=scss&scoped=true"
import style1 from "./payment-success.vue?vue&type=style&index=1&id=9851d6b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9851d6b0",
  null
  
)

export default component.exports